export default "__VITE_ASSET__CnwOmN$8__"